 
// src/redux/reducers/jobCategoriesReducer.js
import {
    FETCH_JOBCATEGORY_FAILURE,
    FETCH_JOBCATEGORY_REQUEST,
    FETCH_JOBCATEGORY_SUCCESS, 
    SET_SELECTED_JOBCATEGORY 
  } from '../types';
  
  const initialState = {
    loading: false,
    jobCategoryList: [],
    selectedJobCatId: null, 
    error: null,
  };
  
  const jobCategoriesReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_JOBCATEGORY_REQUEST:
        return { ...state, loading: true };
      case FETCH_JOBCATEGORY_SUCCESS:
        return { ...state, loading: false, jobCategoryList: action.payload };
      case FETCH_JOBCATEGORY_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_JOBCATEGORY:
        return { ...state, selectedJobCatId: action.payload };
      default:
        return state;
    }
  };
  
  export default jobCategoriesReducer;
  